export const SET_FACEBOOK_DATA = "SET_FACEBOOK_DATA";
export const SET_FACEBOOK_DATA_NULL = "SET_FACEBOOK_DATA_NULL";
export const SET_FACEBOOK_DATA_PREVIOUS = "SET_FACEBOOK_DATA_PREVIOUS";
export const SET_FACEBOOK_DATA_PREVIOUS_NULL =
  "SET_FACEBOOK_DATA_PREVIOUS_NULL";
